<template>
    <div>
        <card-header title="Survey Questions" icon="fa-question-circle"></card-header>

        <card-toolbar>
            <button @click="$openCard('rmc-new-session-survey-question', {sessionId: session.id}, card)"><i class="far fa-plus"></i>New Question</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <draggable v-model="session.survey" handle=".handle" @change="updateOrder">
                    <transition-group>
                        <rmc-question-tile
                            :card="card"
                            :question="question"
                            v-for="question in session.survey"
                            :active="(child && child.definition.component === 'rmc-edit-session-survey-question' && question.id === parseInt(child.props.questionId))"
                            @click="$openCard('rmc-edit-session-survey-question', {sessionId: session.id, confId: conference.id, questionId: question.id}, card)"
                            :key="question.id"
                            class="t-card-list-item"
                        />
                    </transition-group>
                </draggable>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import CardToolbar from "@/TIER/components/CardToolbar";

    import draggable from 'vuedraggable';

    import {client as http} from "@/http_client";
    import RmcQuestionTile from "../../../components/rmc/RmcQuestionTile";
    import async from "async";

    export default {
        components: {RmcQuestionTile, CardToolbar, CardList, CardHeader, CardBody, draggable},
        props: ['card', 'props', 'child'],
        data() {
            return {
                session: {
                    enrollments: []
                },
                conference: {}
            }
        },

        methods: {
            loadSession: function(force) {
                this.$emit('loading', true);
                async.series([
                    (cb) => {
                        http.get('rmc/conferences/' + this.props.confId, {force}).then(response => {
                            this.conference = response.data;
                            cb();
                        }).catch(err => {
                            cb(err);
                        });
                    },
                    (cb) => {
                        http.get('rmc/sessions/' + this.props.sessionId, {force}).then(response => {
                            this.session = response.data;
                            cb();
                        }).catch(err => {
                            cb(err);
                        });
                    }
                ], err => {
                    this.$emit('loading', false);
                })

            },
            updateOrder: function() {
                let order = [];
                for (let i = 0; i < this.session.survey.length; i++) {
                    order.push(this.session.survey[i].id)
                }
                http.post('rmc/sessions/' + this.props.sessionId + '/survey/order', {order}).then(response => {

                }).catch(err => {

                });
            },
            reload: function() {
                this.loadSession(true);
            }
        },
        mounted() {
            this.loadSession();
        }
    }
</script>

<style>

</style>
